
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/friends-referral",
      function () {
        return require("private-next-pages/friends-referral.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/friends-referral"])
      });
    }
  